import { IIconProps } from "../types"

export default function IconLR3(props: IIconProps) {
  const width = props.size || props.width || 69
  const height = props.size || props.height || 102
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 69 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4465 0.803344C28.7965 0.213344 30.6165 0.343344 32.6965 1.32334C34.7865 2.30334 37.1265 4.12334 41.0365 6.69334C44.9365 9.26334 50.4065 12.5833 54.2465 15.1933C58.0865 17.7933 60.3065 19.6833 62.3865 21.8333C64.4765 23.9833 66.4265 26.3933 67.4065 28.8333C68.3765 31.2733 68.3765 33.7433 66.9165 42.3033C65.4465 50.8633 62.5165 65.5133 60.2065 75.1533C57.8965 84.7833 56.2065 89.4133 54.3465 92.9233C52.4965 96.4433 50.4765 98.8533 47.2165 100.183C43.9665 101.523 39.4665 101.783 35.3065 101.323C31.1365 100.863 27.2965 99.6933 24.1365 96.8933C20.9865 94.0933 18.5065 89.6733 15.8365 83.6133C13.1665 77.5633 10.3065 69.8733 7.92651 62.7533C5.55651 55.6233 3.66651 49.0433 2.42651 43.3433C1.18651 37.6533 0.606515 32.8333 0.476515 28.9633C0.346515 25.0833 0.666515 22.1533 1.74651 19.6133C2.81651 17.0733 4.63651 14.9333 7.53651 12.3933C10.4365 9.85334 14.4065 6.92334 17.8265 4.80334C21.2465 2.69334 24.1065 1.38334 26.4465 0.803344Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
